export interface UploadFileCandidate {
  filename?: string;
  name?: string;
}

export function sanitizeBlobFileName(fileName: string): string {
  return String(fileName || '').trim().replace(/\s+/g, '-');
}

export function sanitizeSelectedUploadFile<T extends UploadFileCandidate>(file: T): T {
  const sanitizedName = sanitizeBlobFileName(file.filename || file.name || '');
  return { ...file, name: sanitizedName, filename: sanitizedName };
}
